import { Controller } from "@hotwired/stimulus";

const RESULT_MODIFIERS = [
  "web-app__url-enforcement-modal-tester-main--positive",
  "web-app__url-enforcement-modal-tester-main--negative",
];

const INVALID_URL_MESSAGE = "Please enter a valid URL";

export default class extends Controller {
  static targets = ["input", "result"];

  validateSubmit(event) {
    if (!this.hasInputTarget) return;

    const input = this.inputTarget;
    input.setCustomValidity("");
    if (input.checkValidity()) return;

    input.setCustomValidity(INVALID_URL_MESSAGE);
    event.preventDefault();
    event.stopImmediatePropagation();
    input.reportValidity();
  }

  clearResultOnInput() {
    if (!this.hasResultTarget) return;

    this.resultTarget.classList.remove(...RESULT_MODIFIERS);

    const badge = this.resultTarget.querySelector(
      ".web-app__url-enforcement-modal-tester-badge",
    );
    if (badge) badge.textContent = "";

    this.resultTarget
      .querySelector(".web-app__url-enforcement-modal-tester-status-icon")
      ?.remove();

    if (this.hasInputTarget) this.inputTarget.setCustomValidity("");
  }
}
